<template>
  <v-container>
    <v-row>
      <v-col md="5" sm="12">
        <v-autocomplete
          autocomplete="off"
          prepend-icon="mdi-view-module-outline"
          :loading="status.loading"
          :label="$t('connector.field.template')"
          v-model="templateId"
          :items="templates"
          item-text="displayName"
          item-value="backendConnectorTemplateId"
        />
      </v-col>

      <v-col md="5" sm="8">
        <v-text-field
          label="value"
          name="value"
          prepend-icon="mdi-domain"
          type="text"
          v-model="value"
        ></v-text-field>
      </v-col>

      <v-col md="2" sm="4">
        <v-btn fab color="primary" medium @click="add">
          <v-icon circle>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-container>
      <v-row v-for="(v, i) in items" v-bind:key="i" class="itemsRemove">
        <v-col md="10" sm="10" class="text-align: left;"
          >{{ getDisplayNameForTemplate(v.templateId) }} -
          {{ getValueForTemplate(v) }}</v-col
        >
        <v-col md="2" sm="2">
          <v-btn fab small color="error" @click="deleteItem(i)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "ConnectorOptions",

  props: {
    data: {
      default: null,
      type: Array
    }
  },

  data() {
    return {
      templateId: "",
      value: "",
      items: []
    };
  },

  created() {
    if (this.data != null) {
      this.items = this.data;
    }

    this.getTemplates(true);
  },

  computed: {
    ...mapState("connectors", ["templates", "status"])
  },

  methods: {
    ...mapActions("connectors", ["getTemplates"]),

    add() {
      if (this.templateId != "" && this.value != "") {
        this.items.push({ templateId: this.templateId, value: this.value });
        this.templateId = "";
        this.value = "";
        this.$emit("update", this.items);
      }
    },

    deleteItem(index) {
      this.items.splice(index, 1);
      this.$emit("update", this.items);
    },

    getDisplayNameForTemplate(templateId) {
      for (let template in this.templates) {
        if (this.templates[template].backendConnectorTemplateId == templateId)
          return this.templates[template].displayName;
      }
    },

    getValueForTemplate(template) {
      // SO password
      if (template.templateId == 2) return "* * * * * * *";

      return template.value;
    }
  },

  watch: {
    data(newVal) {
      if (newVal != null) this.items = this.data;
    }
  }
};
</script>

<style scoped>
.itemsRemove {
  text-align: left;
}
</style>
